export const verificationOptionsErrorKeys = [
  'lexisNexisButtonText',
  'authenticatorButtonText',
  'authenticatorID',
  'lexisNexisAppInstanceID',
]
